module.exports = __webpack_public_path__ + "img/icon-grid-list.e74dae6d.svg";